import React from 'react';

const themes = {
    light: {
        NeutralColor: '#FFFFFF', 
        AccentColor: '#1E1E1E',
        PrimaryColor: '#FF4C4C',
        SecondaryColor: '#FFC0CB',
        GreyColor: '#B0B0B0',
    },
    dark: {
        NeutralColor: '#1E1E1E', 
        AccentColor: '#FFFFFF',
        PrimaryColor: '#FF4C4C',
        SecondaryColor: '#FFC0CB',
        GreyColor: '#B0B0B0',
    },
};

const ThemeContext = React.createContext(themes.light);

export { themes, ThemeContext };
